export default {
    Audio : 'Audio',
    Video : 'Video',
}